import * as actions from '../filters';
const filters = ({ getState, dispatch }) => (next) => async (action) => {
    // if (action.type !== actions.filtersOnUpdate.type) return next(action);
    const state = getState();
    // console.log("Filters Middleware: action", action);
    switch (action.type) {
        case actions.filtersOnUpdate.type:
            // Handle filters update
                    let { filters } = action.payload;
                    dispatch({
                        type: action.payload.onSuccess,
                        payload: {"filters" : filters},
                    })
            break;
        case actions.onFilterByUpdate.type:
            // Handle filter by update
            let { filterBy} = action.payload;
            dispatch({
                type: action.payload.onSuccess,
                payload: {"filterBy" : filterBy},
            })
            break;
        case actions.onSortCriteriaUpdate.type:
            // Handle sort criteria update
            let { sortCriteria } = action.payload;
            dispatch({
                type: action.payload.onSuccess,
                payload: {"sortCriteria" : sortCriteria},
            })
            break;
        case actions.onParamsUpdate.type:
            // Handle params update
            let { params } = action.payload;
            dispatch({
                type: action.payload.onSuccess,
                payload: {"params" : params},
            })
            break;
        case actions.onResetTotal.type:
            // Handle reset total
            dispatch({
                type: action.payload.onSuccess,
                payload: {"totalSize" : 0},
            })
            break;
        case actions.onPageChange.type:
            // Handle page change
            let { pageNo, maxPageNo } = action.payload;
            let payload = {"pageNo" : pageNo ? pageNo : 1, "maxPageNo": maxPageNo ? maxPageNo : -1};
            dispatch({
                type: action.payload.onSuccess,
                payload: payload,
            })
            break;
        case actions.onViewChange.type:
            // Handle view change
            let { viewType } = action.payload;
            dispatch({
                type: action.payload.onSuccess,
                payload: {"viewType" : viewType},
            })
            break;
        default:
            return next(action);
    }
}
export default filters;